import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CardContent, Stack, Typography } from '@mui/material';
import { parseAmount } from '@utils';
import AreaItem from './AreaItem';
import styles from './AreaItem.styles';

export interface Area {
  id: string;
  name: string;
  fantasyName: string;
  balance: number;
  costCenter: string | null;
}

interface AreasListProps {
  areas: Area[];
  balanceAvailable: string;
}

/**
 * Component that renders a list of available areas for a given company.
 *
 * @param areas The list of areas to be displayed.
 * @returns The rendered component.
 */
const AreasList: FC<AreasListProps> = ({ areas, balanceAvailable }) => {
  const { t } = useTranslation();
  const balance = balanceAvailable ? parseAmount(Number(balanceAvailable)) : '-';

  return (
    <>
      <CardContent>
        <Stack spacing={1.5}>
          <Typography variant='h2'>{t('CLIENTS:DETAIL:AREAS:TITLE')}</Typography>
          <Stack direction='column' alignItems='flex-start' gap={2}>
            {areas.map((area) => (
              <AreaItem key={area.id} area={area} />
            ))}
          </Stack>
        </Stack>
      </CardContent>
      <CardContent>
        <Box sx={styles.container}>
          <Typography variant='h4'>{t('COMMON:BALANCE_AVAILABLE')}</Typography>
          <Typography variant='h4'>{balance}</Typography>
        </Box>
      </CardContent>
    </>
  );
};

export default AreasList;
